<template>
  <div id="app">
    <Header></Header>
    <main class="main">
      <router-view></router-view>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/views/_common/Header/index.vue';
import Footer from '@/views/_common/Footer/index.vue';
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>
<style lang="scss">
:root{
  --global-nav-height: 44px;
}
body{
  font-size: 14px;
  font-family: "SF Pro SC","HanHei SC","SF Pro Text","Myriad Set Pro","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif;
}
.main{
  width: 100%;
  min-height: 100vh;
  min-width: 1226px;
}
body,html{
  background: #f5f5f5;
}
ul,div,h1,h2,h3,p,figure,body,html{
    margin: 0;
    padding: 0;
}
li{
    list-style: none;
}
.container{
  width: 1226px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue